import { AxiosResponse } from 'axios';
import { IQuoteImportStatusApi, api } from '../base';
import { KeyValue } from '@/main/models/common';
import { Result } from '@/main/models/common/resultResponse';

const baseRoute: string = 'QuoteImportStatus';

export class QuoteImportStatusApi extends IQuoteImportStatusApi {
  getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/getDomain`);
  }
}

